export const OPEN_MARKET_PAGE_TITLE = 'OpenMarket';
export const openMarketNoAccessDescription =
  'See an underwriter’s catalog of active Deal Roadshow-linked transactions across credit products and countries from their OpenMarket profile on Finsight.com. ';
export const openMarketNoAccessFeatures = [
  'Filter by industry, sector, region and offering type to discover new opportunities',
  'See a transaction’s sector, country, target proceeds and other applicable details',
  'Instantly access relevant deal documentation, call details and more on Deal Roadshow',
];
export const openMarketImageCaption = 'Underwriters provide access to their OpenMarket profile via whitelist.';
